import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"check\"><path d=\"M3.414 8.414l2.999 3 6.001-6c1-1 0-2-1-1l-5.001 5-1.999-2c-1-1-2 0-1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol